// Domain tool illustrations (Higgsfield; R&W in the red/gold identity palette,
// math in blue/gold). Each domain IS a tool — the metaphor is the identity.
// Shown inside a domain's own page and as the card art on the subject page's
// path (2026-07-14). Processed: backgrounds/shadows stripped, 512px.
import info from './domain-tool-info.png';
import craft from './domain-tool-craft.png';
import expression from './domain-tool-expression.png';
import conventions from './domain-tool-conventions.png';
import algebra from './domain-tool-algebra.png';
import advanced from './domain-tool-advanced.png';
import geotrig from './domain-tool-geotrig.png';
import psda from './domain-tool-psda.png';

export const DOMAIN_TOOL_ART = { info, craft, expression, conventions, algebra, advanced, geotrig, psda };

export const DOMAIN_TOOL_TAGLINES = {
  info: 'The magnifying glass: examining, locating, verifying.',
  craft: "The key: unlocking what a word or passage actually means and how it's built.",
  expression: 'The paintbrush: shaping raw material into something coherent and intentional.',
  conventions: 'The wrench: tightening loose parts so the whole thing works.',
  algebra: 'The balance: whatever you do to one side, you do to the other.',
  advanced: 'The curve: growth that leaves straight lines behind.',
  geotrig: 'The compass: shapes, angles, and distances drawn to measure.',
  psda: 'The dice: chance, data, and what the numbers actually say.',
};
